import { gql } from '../../../../../hooks'

export const DELETE_MODELS = gql`
  mutation AdministrationDeleteMachineModels($id: ID!) {
    aDelete(path: "machine/models", id: $id) {
    }
  }
`

export const LIST_MODELS = gql`
  query AdministrationListMachineModels(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(path: "machine/models", filter: $filter, page: $page, limit: $limit) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
